/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getDrafts.defs'
export { main as default } from './getDrafts.defs'
